import { TypographyHeading } from "shared/molecules/typography-layout";
import { TeacherFilter } from "./filter";
import { Box, InputLabel, Paper, FormControl, Select, MenuItem, Pagination } from "@mui/material";
import Loader from "pages/build-test/loader";
import { useEffect, useState } from "react";
import { GET_TEACHERS } from "utils/graphql/services/live-classes/queries";
import { useLazyQuery } from "@apollo/client";
import NoDataFound from "shared/molecules/no-data";
import { Stack } from "@mui/material";
import { table } from "./helper";
import liveClassClientService from "utils/graphql/liveclassClient";
import { utcToIst } from "utils/time-util/utcIstTime";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";

export default function Teachers() {
  const [searchPayload, setSearchPayload] = useState({});
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [getTeachersList, { loading, error, data }] = useLazyQuery(
    GET_TEACHERS,
    {
      client: liveClassClientService,
    },
  );

  useEffect(() => {
    getTeachersList({
      variables: {
        input: {
          limit: limit,
          offset: (page - 1) * limit,
          ...searchPayload,
        },
      },
    });
  }, [page, limit, searchPayload, getTeachersList]);

  const teacherTableData = (data?.getTeachers?.teachers || []).map((t) => ({
  ...t,
  employeeCode: t?.employee?.id,
  empFirstName: t?.employee?.firstName,
  empLastName: t?.employee?.lastName,
  createdAt: utcToIst(t.createdAt),
  updatedAt: utcToIst(t.updatedAt),
}));

  return (
    <>
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        Teachers
      </TypographyHeading>

      <TeacherFilter setSearchPayload={setSearchPayload} setPage={setPage} />

      <Paper elevation={2} sx={{ p: 2, mt: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <FormControl size="small" sx={{ width: 140 }}>
            <InputLabel>Show Entries</InputLabel>
            <Select
              value={limit}
              label="Show Entries"
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(1);
              }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={500}>500</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <div>
          {loading && <Loader />}
          
          {!loading && data?.getTeachers?.teachers?.length > 0 ? (
            <CollapsibleTable
              data={teacherTableData}
              table={table}
              id="id"
              name="id"
              rowsPerPageCount={limit}
              style="false"
              totalRecords={data?.getTeachers?.totalCount || 0}
              paginationSegmentApi="false"
              viewSecondaryData="false"
              showPaginationFooter={false}
            />
          ) : (
            <div>{!loading && <NoDataFound message="No Data Found" />}</div>
          )}
        </div>

        <Box sx={{ marginTop: "20px" }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Pagination
              count={Math.ceil(data?.getTeachers?.totalCount / limit) || 1}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
              size="medium"
            />
          </Stack>
        </Box>
      </Paper>
    </>
  );
}
